import { OndemandVideo } from '@mui/icons-material';
import { useFormik } from 'formik';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useCreateChannel } from '~/api/channels';
import { applyServerErrors } from '~/api/helpers';
import { RouterBreadcrumbs } from '~/components/RouterBreadcrumbs';
import { SaveButton } from '~/components/button';
import { PageContainer } from '~/components/page-layout';
import { Toolbar } from '~/components/toolbar';
import { useAppContext } from '~/contexts';
import { ChannelEncryptionKind } from '~/generated/graphql';
import { useLink } from '~/hooks/link';
import { usePaginationParams } from '~/hooks/pagination';
import { ChannelForm, channelSchema } from './components/form';

export const NewChannel = () => {
  const { t } = useTranslation();
  const { currentNetwork } = useAppContext();

  const navigate = useNavigate();

  const link = useLink();

  const [searchParams] = useSearchParams();
  const search = searchParams.get('search')?.trim() || '';
  const { page, perPage } = usePaginationParams();

  const [createChannel] = useCreateChannel();

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      // eslint-disable-next-line no-restricted-syntax -- user-picked value, not a theme color
      backgroundColor: '#000000',
      encryption: ChannelEncryptionKind.None,
      name: '',
      number: '',
      source: '',
      thumbnailUri: '',
      url: '',
      urls: [],
      outputUrl: '',
      outputUrls: [],
      enabledForLiveStreaming: false,
      jpegxsEnabled: false,
    },
    onSubmit: async (input, { setErrors }) => {
      const result = await createChannel({
        variables: { input: { ...input, networkId: currentNetwork.id }, page, perPage, search },
      });
      applyServerErrors(result, setErrors);
      if (result.errors) return;
      navigate(link('/channels'));
    },
    validateOnMount: true,
    validationSchema: channelSchema,
  });

  return (
    <>
      <Toolbar
        actions={
          <SaveButton
            disabled={formik.isSubmitting || !formik.isValid || !formik.dirty}
            type="submit"
            form="new-channel"
          />
        }
        breadcrumbsLabel={<RouterBreadcrumbs />}
        titleIcon={<OndemandVideo />}
        titleText={t('pages.channels.title')}
      />

      <PageContainer>
        <ChannelForm formik={formik} formId="new-channel" />
      </PageContainer>
    </>
  );
};
